var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    contentScriptType: "text/ecmascript",
    width: 375,
    zoomAndPan: "magnify",
    contentStyleType: "text/css",
    viewBox: "0 0 375 374.999991",
    height: 374.999991,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 214 146 L 243.125 146 L 243.125 203 L 214 203 Z M 214 146 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 130.625 146 L 216 146 L 216 258.496094 L 130.625 258.496094 Z M 130.625 146 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 187.65625 99.53125 C 138.988281 99.53125 99.53125 138.988281 99.53125 187.65625 C 99.53125 236.328125 138.988281 275.78125 187.65625 275.78125 C 236.328125 275.78125 275.78125 236.328125 275.78125 187.65625 C 275.78125 138.988281 236.328125 99.53125 187.65625 99.53125 Z M 187.65625 99.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0.779724%, 6.669617%, 13.729858%)",
    d: "M 187.347656 116.847656 C 148.414062 116.847656 116.847656 148.414062 116.847656 187.347656 C 116.847656 226.285156 148.414062 257.847656 187.347656 257.847656 C 226.285156 257.847656 257.847656 226.285156 257.847656 187.347656 C 257.847656 148.414062 226.285156 116.847656 187.347656 116.847656 Z M 187.347656 116.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 175.007812 202.34375 L 174.5 202.089844 L 202.546875 146 L 203.179688 146 L 175.007812 202.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 183.007812 202.328125 L 182.503906 202.074219 L 210.539062 146 L 211.171875 146 L 183.007812 202.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 177.675781 202.339844 L 177.167969 202.085938 L 205.210938 146 L 205.84375 146 L 177.675781 202.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 180.34375 202.332031 L 179.835938 202.078125 L 207.875 146 L 208.507812 146 L 180.34375 202.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 172.34375 202.351562 L 171.835938 202.097656 L 199.882812 146 L 200.519531 146 L 172.34375 202.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 242.5 146 L 243.136719 146 L 215.007812 202.253906 L 214.503906 202 L 242.5 146 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 161.675781 202.375 L 161.167969 202.121094 L 189.226562 146 L 189.863281 146 L 161.675781 202.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 167.007812 202.363281 L 166.503906 202.109375 L 194.554688 146 L 195.191406 146 L 167.007812 202.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 164.34375 202.367188 L 163.835938 202.117188 L 191.890625 146 L 192.527344 146 L 164.34375 202.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 169.675781 202.355469 L 169.167969 202.105469 L 197.21875 146 L 197.855469 146 L 169.675781 202.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 199.007812 202.289062 L 198.503906 202.035156 L 226.519531 146 L 227.152344 146 L 199.007812 202.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 201.675781 202.285156 L 201.167969 202.03125 L 229.183594 146 L 229.816406 146 L 201.675781 202.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 204.34375 202.277344 L 203.835938 202.023438 L 231.847656 146 L 232.480469 146 L 204.34375 202.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 185.675781 202.320312 L 185.167969 202.066406 L 213.203125 146 L 213.835938 146 L 185.675781 202.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 212.34375 202.261719 L 211.835938 202.007812 L 239.839844 146 L 240.472656 146 L 212.34375 202.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 209.675781 202.265625 L 209.167969 202.011719 L 237.175781 146 L 237.808594 146 L 209.675781 202.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 207.007812 202.273438 L 206.5 202.019531 L 234.511719 146 L 235.144531 146 L 207.007812 202.273438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 191.007812 202.308594 L 190.503906 202.054688 L 218.527344 146 L 219.164062 146 L 191.007812 202.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 188.34375 202.316406 L 187.835938 202.0625 L 215.863281 146 L 216.5 146 L 188.34375 202.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 196.34375 202.296875 L 195.835938 202.042969 L 223.855469 146 L 224.488281 146 L 196.34375 202.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 193.675781 202.300781 L 193.167969 202.050781 L 221.191406 146 L 221.828125 146 L 193.675781 202.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96.859741%, 97.24884%, 93.728638%)",
    d: "M 186.882812 258.507812 L 130.628906 146 L 186.882812 146 L 215.007812 202.253906 L 186.882812 258.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsta);
export default __webpack_public_path__ + "static/media/vsta.d40dbd327ae21241a476fba8ada045a8.svg";
export { ForwardRef as ReactComponent };